var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAddOutLined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49092 13.4844C5.28759 13.4844 2.55176 13.9685 2.55176 15.9085C2.55176 17.8485 5.27092 18.3502 8.49092 18.3502C11.6951 18.3502 14.4301 17.8652 14.4301 15.926C14.4301 13.9869 11.7118 13.4844 8.49092 13.4844Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49141 10.7168C10.5939 10.7168 12.2981 9.01268 12.2981 6.91018C12.2981 4.80768 10.5939 3.10352 8.49141 3.10352C6.38974 3.10352 4.68557 4.80768 4.68557 6.91018C4.67807 9.00518 6.36974 10.7093 8.46557 10.7168H8.49141Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2633 8.03711V11.3788",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9689 9.70768H14.5605",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAddOutLined);
export default __webpack_public_path__ + "static/media/UserAddOutLined.b46c6ca1ff422b1128da9bcfa1607b0c.svg";
export { ForwardRef as ReactComponent };